// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.driver-chat-modal-chat-history-container {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: auto;
    padding: 8px 24px;
    height: 200px;
}

.driver-chat-modal-loading-container {
    position: absolute;
    bottom: 40px;
    width: 100%;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./routes/app/components/DriverChatModal.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["\n.driver-chat-modal-chat-history-container {\n    border: 1px solid #e8e8e8;\n    border-radius: 4px;\n    overflow: auto;\n    padding: 8px 24px;\n    height: 200px;\n}\n\n.driver-chat-modal-loading-container {\n    position: absolute;\n    bottom: 40px;\n    width: 100%;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
